import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';
import { appInsights } from '../../../AppInsights';
import AdImg from '../../../assets/images/inlightened_ad.png';

// Identifies this banner/campaign in analytics so events can be grouped regardless of the
// destination URL. Update alongside the href/image when the campaign changes.
const AD_NAME = 'inlightened_expert_signup';
const AD_DESTINATION =
    'https://app.getinlightened.com/auth/signup/expert?utm_source=locumtenens&utm_medium=banner&utm_campaign=ltoe_expert_signup';

const styles = (theme) => ({
    desktopWrapper: {
        display: 'flex',
        borderBottom: `1px solid ${COLORS.WHITE_LILAC}`,
        paddingLeft: '20px',
        marginTop: '32px',
        paddingBottom: '32px',
        flexDirection: 'column',
        textAlign: 'left',
    },
    header: {
        color: COLORS.ST_TROPAZ,
        fontWeight: '700',
        fontSize: '18px',
        margin: 0,
    },
    spanTitleFont: {
        fontWeight: '900',
        color: COLORS.RAVEN,
        fontSize: '12px',
        display: 'flex',
        textTransform: 'uppercase',
    },
    emptyStateWrapper: {
        display: 'flex',
    },
    innerCardEmptyWrapper: {
        margin: '10px 20px',
        display: 'flex',
        padding: '10px',
        borderRadius: '5px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-around',
        border: `1px solid ${COLORS.WHITE_LILAC}`,
        [theme.breakpoints.down('sm')]: {
            margin: '10px 10px',
        },
    },
    dateFont: {
        fontWeight: '300',
        textTransform: 'uppercase',
    },
    addressWrapper: {
        paddingBottom: '16px',
    },
    addressFont: {
        fontWeight: '500',
        fontSize: '14px',
        color: COLORS.RAVEN,
    },
    emptyStateHeader: {
        textAlign: 'left',
        fontWeight: '700',
        letterSpacing: '0',
        fontSize: '20px',
        color: COLORS.RAVEN,
        opacity: '0.3',
    },
    presentDate: {
        display: 'flex',
        flexFlow: 'column',
    },
});

class AdCard extends Component {
    constructor(props) {
        super(props);
        this.adRef = React.createRef();
        this.hasTrackedImpression = false;
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        // Fire a single impression event the first time the ad scrolls into view, rather than on
        // mount, so we don't count ads that render below the fold and are never seen.
        if (typeof IntersectionObserver === 'undefined' || !this.adRef.current) return;

        this.observer = new IntersectionObserver(
            (entries) => {
                const isVisible = entries.some((entry) => entry.isIntersecting);
                if (isVisible && !this.hasTrackedImpression) {
                    this.hasTrackedImpression = true;
                    appInsights.trackEvent({
                        name: 'AdCardViewed',
                        properties: { adName: AD_NAME, destinationUrl: AD_DESTINATION },
                    });
                    this.observer.disconnect();
                }
            },
            // Count it as seen once at least half the banner is within the viewport.
            { threshold: 0.5 }
        );
        this.observer.observe(this.adRef.current);
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    handleClick() {
        appInsights.trackEvent({
            name: 'AdCardClicked',
            properties: { adName: AD_NAME, destinationUrl: AD_DESTINATION },
        });
    }

    render() {
        return (
            <div ref={this.adRef}>
                <a
                    href={AD_DESTINATION}
                    target="_blank"
                    rel="noreferrer"
                    onClick={this.handleClick}
                >
                    <img src={AdImg} alt="Ad" style={{ maxWidth: '100%', height: 'auto' }} />
                </a>
            </div>
        );
    }
}

export default withTranslation()(withStyles(styles)(AdCard));
